"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const util_1 = require("@app/util");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const _ui_1 = require("@ui");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
require("./style.scss");
const TYPES = Object.freeze({
    VARIABLE: 'variable',
    STATIC: 'static',
});
const STYLES = Object.freeze({
    LIGHT: 'light',
    OUTLINED: 'outlined',
    BORDERLESS: 'borderless',
});
const SIZES = Object.freeze({
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    EXTRA: 'extra',
    FULL_WIDTH: 'full-width',
});
const EXTRA_POSITION = Object.freeze({
    TOP: 'TOP',
    BOTTOM: 'BOTTOM',
});
const Dropdown = (props) => {
    const { options, placeholder, onChange, type, size, style, value, icon, label, searchable, onSearch, disabled, hasError, errorMessage, singleSelect, sortedOptions, extraDropdownContent, extraDropdownContentPosition, isCancelButtonHidden, disableSort, cb, testid, } = props;
    const floatable = (0, util_1.useFloatable)(cb);
    const searchInput = (0, react_1.useRef)(null);
    let selectedOptions = Array.isArray(value) ? value : value ? [value] : [];
    selectedOptions = selectedOptions.filter(Boolean);
    const [searchText, setSearchText] = (0, react_1.useState)('');
    const addedTitles = [];
    const addSeparator = false;
    const handleChange = (option) => {
        if (singleSelect) {
            onChange(option);
            if (floatable.open)
                floatable.setOpen(false);
        }
        else {
            const hasSame = selectedOptions.some((item) => item.value === option.value);
            onChange(hasSame
                ? [...selectedOptions.filter((item) => item.value !== option.value)]
                : [...selectedOptions, option]);
        }
        searchable && searchInput.current && searchInput.current.focus();
    };
    const handleGroupChange = ({ groupTitle }) => {
        const allGroupOptions = transformedOptions.filter((option) => option.groupTitle === groupTitle);
        const selectedWithoutGroup = selectedOptions.filter((option) => option.groupTitle !== groupTitle);
        if (selectedOptions.filter((option) => option.groupTitle === groupTitle).length ===
            allGroupOptions.length) {
            // @ts-expect-error
            onChange(selectedWithoutGroup);
        }
        else {
            // @ts-expect-error
            onChange([...selectedWithoutGroup, ...allGroupOptions]);
        }
    };
    const transformOptions = () => {
        if ((0, util_1.isUndefined)(options))
            return [];
        const sortOptions = (filteredOptions) => filteredOptions.sort((a, b) => {
            const sortSelected = +selectedOptions.some((item) => item.value === b.value) -
                +selectedOptions.some((item) => item.value === a.value);
            if (!sortedOptions)
                return 1;
            if (a.groupTitle && b.groupTitle) {
                if (a.groupTitle > b.groupTitle)
                    return 1;
                if (a.groupTitle < b.groupTitle)
                    return -1;
                if (a.groupTitle === b.groupTitle) {
                    if (sortSelected === 0 || singleSelect) {
                        if ((a.label ?? 0) > (b.label ?? 0))
                            return 1;
                        if ((a.label ?? 0) < (b.label ?? 0))
                            return -1;
                    }
                    else {
                        return sortSelected;
                    }
                }
            }
            else {
                if (sortSelected === 0 || singleSelect) {
                    if ((a.label ?? 0) > (b.label ?? 0))
                        return 1;
                    if ((a.label ?? 0) < (b.label ?? 0))
                        return -1;
                }
                else {
                    return sortSelected;
                }
            }
            return 0;
        });
        const filterOptionsBySearchText = (opts) => {
            if (!searchText)
                return opts;
            return opts.filter((option) => util_1.miscUtil
                .normalizeString(option.searchableParam || option.label || option.value)
                .includes(util_1.miscUtil.normalizeString(searchText)));
        };
        if (disableSort)
            return filterOptionsBySearchText(options);
        if (onSearch)
            sortOptions(options);
        if (!searchText && singleSelect) {
            return sortOptions(options);
        }
        else {
            return sortOptions(filterOptionsBySearchText(options));
        }
    };
    const renderDropdownLeftPart = () => {
        const standard = (react_1.default.createElement(react_1.default.Fragment, null,
            icon && icon,
            placeholder || (0, util_1.t)('CHOOSE')));
        if (type === TYPES.VARIABLE) {
            if (floatable.open) {
                if (searchable) {
                    return (react_1.default.createElement("input", { value: searchText, onChange: (e) => {
                            if (onSearch)
                                onSearch(e.target.value);
                            setSearchText(e.target.value);
                        }, placeholder: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('SEARCH')), autoFocus: true, ref: searchInput }));
                }
                else if (singleSelect) {
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        icon && icon,
                        selectedOptions.length ? selectedOptions[0].label : placeholder));
                }
                else {
                    return standard;
                }
            }
            else {
                if (selectedOptions.length > 1) {
                    return (react_1.default.createElement("div", { className: 'dropdown-badge' }, `${selectedOptions.length} ${size !== SIZES.SMALL ? (0, util_1.t)('SELECTED_MULTIPLE') : ''}`));
                }
                else if (selectedOptions.length === 1) {
                    return react_1.default.createElement("div", { className: 'single-item' }, selectedOptions[0].label);
                }
                else {
                    return standard;
                }
            }
        }
        else {
            return standard;
        }
    };
    const arrowDown = react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.arrowDown, size: _ui_1.Icon.SIZES.SMALL });
    const transformedOptions = transformOptions();
    return (react_1.default.createElement("div", { "data-testid": testid, className: (0, classnames_1.default)('ds-dropdown-new', size, type, style, {
            'dropdown-disabled': disabled,
            'has-error': hasError,
        }) },
        label && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(_ui_1.Text, { weight: _ui_1.Text.WEIGHTS.BOLD, type: _ui_1.Text.TYPES.BODY_MEDIUM, text: label }),
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_6 }))),
        react_1.default.createElement("div", { className: 'dropdown-container', ...floatable.floatAnchor, onClick: disabled ? undefined : floatable.floatAnchor.onClick, onKeyDown: disabled ? undefined : floatable.floatAnchor.inKeyDown, onMouseDown: disabled ? undefined : floatable.floatAnchor.onMouseDown },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('left', {
                    multiple: !floatable.open && selectedOptions.length > 1,
                    bold: style !== STYLES.LIGHT,
                    static: type === TYPES.STATIC,
                    variable: type === TYPES.VARIABLE,
                }) }, renderDropdownLeftPart()),
            react_1.default.createElement("div", { className: 'right' }, type === TYPES.STATIC ? (react_1.default.createElement(react_1.default.Fragment, null, selectedOptions.length ? (react_1.default.createElement("div", { className: 'small-badge' }, selectedOptions.length)) : (arrowDown))) : (arrowDown))),
        floatable.open && (react_1.default.createElement("div", { className: 'dropdown-options', ...floatable.floatContainer },
            !singleSelect && !isCancelButtonHidden && (react_1.default.createElement(react_1.default.Fragment, null,
                selectedOptions.length ? (react_1.default.createElement("div", { className: 'dropdown-cancel ' +
                        (!selectedOptions.length || disabled ? 'cancel-disabled' : ''), onClick: () => disabled ? undefined : !!selectedOptions.length && onChange([]) },
                    (0, util_1.t)('CANCEL_ALL'),
                    !!selectedOptions.length && ` (${selectedOptions.length})`)) : (react_1.default.createElement("div", { className: 'dropdown-cancel ' +
                        (!transformedOptions.length || disabled ? 'cancel-disabled' : ''), onClick: () => disabled ? undefined : onChange(transformedOptions) },
                    (0, util_1.t)('SELECT_ALL'),
                    !!transformedOptions.length && ` (${transformedOptions.length})`)),
                react_1.default.createElement("div", { className: 'dropdown-title-separator' }))),
            extraDropdownContent &&
                extraDropdownContentPosition === EXTRA_POSITION.TOP && (react_1.default.createElement("div", { className: 'extraContent' }, extraDropdownContent)),
            transformedOptions.map((option, key) => {
                let addTitle = true;
                if (addedTitles.some((title) => title === option.groupTitle)) {
                    addTitle = false;
                }
                if (addTitle) {
                    if ((0, util_1.isDefined)(option.groupTitle)) {
                        addedTitles.push(option.groupTitle);
                    }
                }
                const allSelectedGroup = selectedOptions.filter((selOption) => selOption.groupTitle === option.groupTitle);
                const allTransformedGroup = transformedOptions.filter((tranOption) => tranOption.groupTitle === option.groupTitle);
                const groupKeySuffix = option.groupTitle ? '-' + option.groupTitle : '';
                return (react_1.default.createElement(react_1.Fragment
                // the index is always part of the key: `value` is not guaranteed unique
                // (the phone prefixes share dial codes — +44 is four countries), and on
                // a duplicate key React keeps the row of an option that the search has
                // already filtered out
                , { 
                    // the index is always part of the key: `value` is not guaranteed unique
                    // (the phone prefixes share dial codes — +44 is four countries), and on
                    // a duplicate key React keeps the row of an option that the search has
                    // already filtered out
                    key: `${option.value?.toString() ?? 'undefined'}-${key}${groupKeySuffix}` },
                    option.groupTitle && addTitle && key !== 0 && (react_1.default.createElement("div", { className: 'dropdown-title-separator' })),
                    option.groupTitle && addTitle && (react_1.default.createElement("div", { className: 'dropdown-title-group' },
                        !singleSelect && (react_1.default.createElement(_ui_1.Checkbox, { type: 'interminate', disabled: disabled, onChange: () => handleGroupChange(option), indeterminate: selectedOptions.some((selOption) => selOption.groupTitle === option.groupTitle), checked: allSelectedGroup.length === allTransformedGroup.length })),
                        react_1.default.createElement("div", { className: 'dropdown-title' }, option.groupTitle))),
                    !singleSelect && addSeparator && (react_1.default.createElement("div", { className: 'dropdown-separator' })),
                    react_1.default.createElement("div", { onClick: () => (disabled ? undefined : handleChange(option)), className: (0, classnames_1.default)('option-item', {
                            'is-selected': selectedOptions.some((item) => item.value === option.value),
                            'is-singleSelect': !!singleSelect,
                            'with-title': !!option.groupTitle,
                        }) },
                        !singleSelect && (react_1.default.createElement(_ui_1.Checkbox, { disabled: disabled, checked: selectedOptions.some((item) => item.value === option.value) })),
                        react_1.default.createElement("div", { className: 'option-value' }, option.label))));
            }),
            !options?.length && react_1.default.createElement(react_1.default.Fragment, null, (0, util_1.t)('NO_OPTIONS')),
            extraDropdownContent &&
                extraDropdownContentPosition === EXTRA_POSITION.BOTTOM && (react_1.default.createElement("div", { className: 'extraContent' }, extraDropdownContent)))),
        hasError && errorMessage ? react_1.default.createElement(_ui_1.Err, { message: errorMessage }) : null));
};
exports.Dropdown = Dropdown;
// Dropdown.propTypes = {
//   // @ts-expect-error
//   options: PropTypes.arrayOf(
//     PropTypes.shape({
//       label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
//       value: PropTypes.oneOfType([
//         PropTypes.string,
//         PropTypes.number,
//         PropTypes.bool,
//       ]),
//       groupTitle: PropTypes.string,
//       searchableParam: PropTypes.string,
//     })
//   ),
//   placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
//   onChange: PropTypes.func.isRequired,
//   type: PropTypes.oneOf(Object.values(TYPES)),
//   size: PropTypes.oneOf(Object.values(SIZES)),
//   style: PropTypes.oneOf(Object.values(STYLES)),
//   // @ts-expect-error
//   value: PropTypes.oneOfType([
//     PropTypes.arrayOf(PropTypes.object),
//     PropTypes.object,
//   ]),
//   icon: PropTypes.node,
//   label: PropTypes.string,
//   searchable: PropTypes.bool,
//   onSearch: PropTypes.func,
//   disabled: PropTypes.bool,
//   hasError: PropTypes.bool,
//   errorMessage: PropTypes.string,
//   singleSelect: PropTypes.bool,
//   sortedOptions: PropTypes.bool,
//   extraDropdownContent: PropTypes.node,
//   extraDropdownContentPosition: PropTypes.oneOf(Object.values(EXTRA_POSITION)),
//   isCancelButtonHidden: PropTypes.bool,
//   disableSort: PropTypes.bool,
//   cb: PropTypes.func,
// }
exports.Dropdown.defaultProps = {
    placeholder: null,
    options: [],
    type: TYPES.STATIC,
    size: SIZES.MEDIUM,
    style: STYLES.OUTLINED,
    value: [],
    icon: null,
    label: null,
    searchable: false,
    onSearch: undefined,
    disabled: false,
    hasError: false,
    errorMessage: undefined,
    singleSelect: false,
    sortedOptions: true,
    isCancelButtonHidden: false,
    extraDropdownContent: null,
    extraDropdownContentPosition: EXTRA_POSITION.BOTTOM,
    disableSort: false,
    cb: undefined,
};
exports.Dropdown.TYPES = TYPES;
exports.Dropdown.SIZES = SIZES;
exports.Dropdown.STYLES = STYLES;
exports.Dropdown.EXTRA_POSITION = EXTRA_POSITION;
